import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails7 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery8.jpg";
    return (
        <>
         <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
            {/* <div className="body_wrap">
        <div className="page_wrap"> */}


            <Header />
            <div
                data-elementor-type="cpt_layouts"
                data-elementor-id="46"
                className="elementor elementor-46"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="52ebb12"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                    style={{ height: "30rem", marginBottom: "5rem" }}
                >
                    <div className="elementor-background-overlay"></div>
                    <div className="elementor-container elementor-column-gap-extended">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
                            data-id="ae9d67e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="fcf91b3"
                                    data-element_type="section"
                                >
                                    <div className="elementor-container elementor-column-gap-extended">
                                        <div
                                            className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                                            data-id="93dfaf4"
                                            data-element_type="column"
                                        >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                                                    data-id="847c2c5"
                                                    data-element_type="widget"
                                                    data-widget_type="spacer.default"
                                                    style={{ height: "8rem" }}
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="elementor-spacer">
                                                            <div className="elementor-spacer-inner"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                                                    data-id="8fe49e3"
                                                    data-element_type="widget"
                                                    data-widget_type="trx_sc_layouts_title.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div
                                                            id="trx_sc_layouts_title_515615674"
                                                            className="sc_layouts_title sc_align_center with_content without_image without_tint"
                                                        >
                                                            <div className="sc_layouts_title_content">
                                                                <div className="sc_layouts_title_title">
                                                                    {" "}
                                                                    
                                                                </div>
                                                                <div className="sc_layouts_title_breadcrumbs">
                                                                    <div className="breadcrumbs">
                                                                       
                                                                       
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



            <div className="page_content_wrap blog-details">
                <div className="content_wrap" >
                    <div className="content">
                        <div id="container" className="give-wrap container">
                            <div id="content" role="main">
                                <div
                                    id="give-form-288-content"
                                    className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                                >
                                    <div
                                        id="give-sidebar-left"
                                        className="give-sidebar give-single-form-sidebar-left"
                                    >
                                        <div className="images">
                                            <img
                                                width="1024"
                                                height="576"
                                                src={img1}
                                                className="attachment-large size-large wp-post-image blog-img"
                                                alt=""
                                                decoding="async"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                            />
                                        </div>
                                    </div>
                                    <div className="summary entry-summary">
                                        <h2 itemProp="name" className="give-form-title entry-title">
                                            પીર પરાજય
                                        </h2>{" "}
                                        <div
                                            id="give-form-288-wrap"
                                            className="give-form-wrap give-display-onpage"
                                        >
                                            <div className="give-goal-progress">
                                                <div
                                                    className="raised blog-title"
                                                    
                                                >
                                                    <span className="income">પીર પરાજય</span>
                                                </div>
                                            </div>

                                            <div
                                                id="give-form-content-288"
                                                className="give-form-content-wrap give_pre_form-content"
                                            >
                                                <p className="paragraph-content">
                                                    પેઠા અસુર થવન મનમાંહી, મને પરખવા આવે આંહીં, અહંકારી સહુ મહા ધમંડી, છળ પ્રપંચ દંભી પાખંડી. યવનોના મનમાં અસુરો પેઠા છે. એટલે એ છળ, પ્રપંચ, દંભ, પાખંડ અને અહંકારમાં ધમંડી બનેલા પીરો ને હકીરો હજારો સંખ્યામાં રશુજા આવવા તૈયાર થયા છે.
                                                    મહા સુદી બીજને દિવસે રામદેવજીએ ભૈરવા રાક્ષસને ભંડાર્યો. ગોરખનાથના શિષ્ય બાલીનાથે ગુરુદક્ષિણા આપી. પરચા વાવડીનાં પાણી ઊભરાવ્યા એથી એ દિવસ અહીંના લોકોમાં પર્વ તરીકે મનાતો હતો. આ પર્વના દિવસે જ પાંચે પીરોનું રણુંજામાં આગમન થયું.
                                                    દોહા

                                                    -રામદેવજી આવિયા, જંગલની મોજાર, પાંચે પીરો આવીને, ઊભા છે એ ઠાર. રામદેવજી સાથે તેમનો સેવક, સવારથીઓ સુતાર પણ હતો. એ જંગલમાં ઊભા હતા, ત્યાં પીરો એમને જોઈ ત્યાં આવીને ઊભા રહ્યા. રામદેવજીએ એમને વિનય અને વિવેકથી પૂછ્યું : 'આપ ક્યાં જવા નીકળ્યા છો ? કયે ગામ જવાનું છે?' એ સાંભળી પોતાની ઓળખ આપતાં એક પીરે
                                                    જણાવ્યું :
                                                    ચોપાઈ
                                                    પાંચે પીરની જગે પ્રસિદ્ધિ, આઠ પ્રકારે સૌની સિદ્ધિ, ચંદ્ર-સૂરજની ગતિ સ્થિર થાયે, મહિમા અગમ અપાર ગણાયે. આલમમાં અમે પાંચે પીર મોટા છીએ. અમે અષ્ટ પ્રકારની સિદ્ધિ પ્રાપ્ત કરી
                                                </p>
                                                <p className="paragraph-content" >
                                                    ભાભા જાતમાં અમારી અપાર પ્રસિદ્ધ પછી શ્રી રામદેવજી બોલ્યા : 'આ પ્રમાણે પીરોએ ઓળખાજી આવ્યા
                                                    ચોપાઈ કહો પીર ક્યાં નીકળ્યા જાવા ? આવીએ સાથે ગામ બતાવા, તમે પ્રવાસી દીસો અય અજાણ્યા, દેખી તમને દેવ પ્રમાળવા. પીરજી ! તમે અજાણ્યા પ્રવાસી છો. દેખાવમાં દેવ જેવા લાગો છો ! તમે કયા ગામ જવાના છો ? કહો તો અમે ગામ અને તમારું ઊતરવાનું સ્થળ સાવીએ.' રામદેવજીની વાત સાંભળી મસ્તાનોપીર બોલ્યો : ૧ ભતાવવા સાથે
                                                    ચોપાઈ
                                                    રામદેવ અજમલસુત નામે, રાજકુંવર છે રણુંજા ગામે, પીર બની પાખંડ ચલાવે. હિન્દુમાં કદી પીર ન થાવે. ગામમાં રામદેવ નામનો રાજકુમાર છે. . એ પીર થઈને પોતાનું પૂજન રણુજા ગામ કરાવવા પાખંડ ચલાવે છે. એવું સાંભળી અમે એને ત્યાં જઈએ છીએ. કોઈ કાળે હિન્દુમાં કોઈ પીર થઈ શકે નહીં. એ સાંભળી રામદેવજી કહેવા લાગ્યા : દોહા
                                                    
                                                    તાપ ટાળવા પીરજી, પીંપળ જો પ્રગટાય, સહુ બેસીએ છાંયડે, વિગતે વાતો થાય.
                                                    ચોપાઈ
                                                    પીર ગણાઓ પીંપળ જેવા, નીચે બેસીએ વાતો કહેવા, અષ્ટ સિદ્ધિના પીર મનાવો, પાંચે પીંપળને પ્રગટાવો. પીરજી ! તમે પાંચે પીર અષ્ટ સિદ્ધિને વરેલા છો, તો પાંચે પીર પાંચ પીંપળ પ્રગટાવો જેથી છાંયડે બેસીને વાતો થાય. પીંપળો ભગવાન મનાય છે. પીરાઈવાળા પણ પીંપળ જેવા મનાય છે.' રામદેવજીએ કહ્યું એટલે મુસોપીર ગુસ્સામાં
                                                    બોલ્યો:
                                                    ચોપાઈ
                                                    તું બાલક શું જાણે ભાઈ, પીરો કેરી ગુપ્ત પીરાઈ. પીંપળ પ્રગટાવું શા માટે ? જઈએ અમે અમારી વાટે.
                                                </p>
                                                <p className="paragraph-content" >
                                                    અભારી પીરોની પીરાઈ નું બાળક શું જાકો ? અમે અમારી વાટે જવામાં વિક કરીને શા માટે પીંપળ પ્રગટ કરવા થોભીએ ?
                                                    ચોપાઈ
                                                    ટૂંક કરે પારમું બાળક મારું ? એક ફૂંકથી બેયને મારૂં, સવારથીઓ પીરથી ગભરાયો, દોડીને ઘરમાં સંતાયો. મુસાપીરે તાડૂકો કરી કહ્યું કે, તું બાલક અમારું પારખું લેવા ધારે છે ? હું મારી તમને બેથને અહીં ભસ્મ કરીશ! આટલું સાંભળતાં સવારથીઓ ભાષમ થઈને નાઠો અને પોતાના ઘરમાં આવીને સંતાઈ ગયો.
                                                    'પીરજી ! જે સાધક સાધ્ય બને છે એ સાધુ સિદ્ધિવાળા હોય છે. એ કોડ, શાપ આપતા નથી. એ તો સંયમી હોય છે. આપ ગુસ્સે ન થશો. આપને બપોો સમય પહેલાં રણુજા પહોંચાડીશ.' એમ કહી રામદેવજીએ પોતાની ઓળખર આપી.

                                                    ચોપાઈ
                                                    રામે પીંપળીઓ પ્રગટાવી, રેશમ કેરી દળી બિછાવી, પીરજી કાઢો કુંડી સોટા, મુજ પાસે છે અફીણ ગોટા. રામદેવજીએ જોતજોતામાં પાંચ પીંપળીઓ પ્રગટાવી. પોતાના ઘોડા પરની રેશમી દળી પાથરી પાંચ પીરને બેસાડયા. અને કહ્યું, પીરજી ! હવે ખરલ મને સોટા કાઢો, હું અફીલનો ગોટો લાવ્યો છું. અમલ કસુંબા લઈ પછી આપણે રણુંજ જઈએ. રામદેવની વાત સાંભળી પીરો બોલ્યા :
                                                    ચોપાઈ
                                                    કુંડી સોટા ઘરે ભુલાયા, નહીં અમારી સાથે લાવ્યા. જૂઠ ન બોલો પીર થઈ મોટા, ઝોળીમાં છે કુંડી સોટા. કુંડી સોટા અમારી સાથે લાવ્યા નથી, પરંતુ ઘેર ભૂલીને આવ્યા છીએ. મસ્તાનાપીરે કહ્યું. ત્યાં તો તરત રામદેવજી બોલ્યા કે મોટાપીર થઈને જૂઠું બોલો છો ? કુંડી સોટા તો તમારી ઝોળીમાં જ છે. હાલ સ
                                                </p>
                                                <p className="paragraph-content" >
                                                    પાંચે જણાંની ઝોળીઓમાંથી નીકળ્યા. પુત્રો અને મસ્તાના સુરત પામીને એકબીજાનાં મોં જોવા લાગ્યા. રામદેવજીએ કુંડીમાં અમલનો ખરલ કર્યા અને પરસ્પર કસુંબા લઈ રહ્યુજ આવ્યા.
                                                    પાંચે પીર સક્ષિત રામદેવજીએ ગામમાં પ્રવેશતાં સાંભળ્યું કે, સવારથીઓ સાપ કરડવાથી મૃત્યુ પામ્યો છે. ગામમાં હાહાકાર થઈ ગયો છે. એના આંગલે સ્ત્રીપુરુષો અને તેનાં કુટુંબીજનો રોકકળ કરી રહ્યાં છે !
                                                    shu સવારથીઆને સર્પ ડસ્યો, અંગૂઠા મોજાર, સોપો પડિયો ગામમાં, વરત્યો હાહાકાર, રામદેવજીએ આ વાત સાંભળતાં જ તેના ઘર તરફ ચાલ્યા.
                                                    ચોપાઈ પીરો આવ્યા ગામ મોજારી, જોવા મળ્યા છે નરનારી, સવારથીઆનું મરણ સુણીને, રામદે આવ્યા પીર લઈને
                                                    પીરોને જોવા સ્ત્રીપુરુષો ઊભાં છે. રામદેવજી પીરો સાથે સવારથીઆને ઘેર આવ્યા. સવારથીઆનું શબ પડ્યું છે અને ચારે બાજુ રોકકળ થઈ રહી છે! આ જોઈ પીરોની સાથે આવેલા રામદેવજીએ સહુને શાંત રહેવાનું અને રોકકળ બંધ કરવાનું કહ્યું.
                                                    રામદેવજીની આજ્ઞાથી બધાં રોતા બંધ થઈ ગયાં. તે પછી રામદેવજીએ પીરોને
                                                    ચોપાઈ
                                                    કહે રામદેવપીર અહીં આવો, કરી સજીવન કળા બતાવો ? પ્રસર્યું ઝેર નસેનસ માંહી, હવે કામ નવ કરે પીરાઈ. પીરજી ! આ છોકરો મારો સાથીદાર છે. તમારાં સત્કાર ને સન્માન માટે તેના
                                                </p>
                                                <p className="paragraph-content" >
                                                    મારી જમણી ભૂજા જેવો છે, એને જીવતદાન દો.” ‘આ છોકરાની નસેનસમાં ઝેર વ્યાપી ગયું છે એટલે એને સજીવન કરવામાં પીરાઈ કામ ન આવે.' પીરોએ કહ્યું 'રામદે' હવે માલિકને બંદગી કરી એને શાન્તિ મળે એવી દુઆ માગવા સિવાય બીજો કોઈ માર્ગ નથી.' આ પ્રમાણે પીરોની વાત સાંભળી રામદે' ઊભા થયા અને
                                                    બોલ્યા :
                                                    દોહા સવારથીઆના શબતણો, પકડયો રામે હાથ. બેઠો કરીને બોલિયા, ચાલ અમારી સાથે.
                                                    'ચાલ, ઊભો થા ભાઈ ! આજે ગામમાં હજારો પીર સાંઈ ફકીર ઓલિયા આવવાના છે. ચાલ અમારી સાથે અને કામે લાગી જા.' આટલું કહેતામાં સવારથીઓ બેઠો થઈ ગયો. સવારથીઆને સજીવન થયેલો જોઈ પીરો આશ્ચર્યમાં ડૂબી ગયા. ત્યાં ઊભેલાં માણસોએ 'રામદેવપીરની જય' કહી આકાશને ગજાવી મૂક્યું અને બધાંના આનંદનો પાર ન રહ્યો.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                </div>
            </div>
            {/* </div>
      </div> */}
            <div>
                <Footer />
                {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
            </div>
        </>
    );
};

export default BlogDetails7;
